import React from 'react';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import IconButton from '@mui/material/IconButton';

const ScrollToTopButton: React.FC = () => {
  const handleScrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <IconButton
      onClick={handleScrollTop}
      aria-label="scroll back to top"
      sx={{ position: 'fixed', bottom: 16, right: 16, color: "var(--ttg-green)", scale: '1.5' }}
    >
      <ArrowUpwardIcon />
    </IconButton>
  );
};

export default ScrollToTopButton;
